import { Pipe, PipeTransform } from "@angular/core";
import { ProjectType } from "@domain/project/project-type.enum";

@Pipe({
  standalone: true,
  name: "localizeProjectType",
})
export class LocalizeProjectTypePipe implements PipeTransform {
  private readonly projectTypeLocalizedStringMap = {
    [ProjectType.OWNED]: $localize`:@@projectType.owned:Eigentümer`,
    [ProjectType.NOT_OWNED]: $localize`:@@projectType.unowned:Kein Eigentümer`,
    [ProjectType.COLLABORATION]: $localize`:@@projectType.collaboration:Kollaboration`,
  };

  transform(value: ProjectType): string {
    return this.projectTypeLocalizedStringMap[value];
  }
}
